module.exports = __webpack_public_path__ + "img/code.9344c6a8.svg";